//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// var FastClick = require('fastclick');
// FastClick.attach(document.body);
import { mapGetters, mapMutations } from 'vuex'
import loading from './components/common/loading'
import encode from './server/api/encode'

export default {
  name: 'app',
  components: {
    loading
  },
  computed: {
    ...mapGetters(["isWeChat","channel",'uid', 'session', 'version', 'guid', 'system']),
    uid () {
      return this.$store.getters.uid
    },
    show () {
      return this.$store.state.base.loading
    },
    mask () {
      return this.$store.state.base.mask
    }
  },
  methods: {
    ...mapMutations([
      'showLoad', 'hideLoad'
    ])
  },
  created () {
    console.log(this.isWeChat, 'http://test-web.yxj.org.cn/wwj-test/yszActivity/819/index.html#/')
  },
  mounted () {
    AppBaseInfoSave(this);
    modifySharePlatforms('3,4,5')
  }
}



// WEBPACK FOOTER //
// ./src/App.vue